import React, { HTMLAttributes, HTMLProps } from 'react';
import { useSelector } from 'react-redux';

import { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import useClasses from '../../hooks/useClasses';
import { DOMAIN_MENTAAL_BALANS, DOMAIN_ZELFHULP_GOKKEN } from '../../config/constants';
import avatarImage1 from '../../assets/images/avatars/avatar-1.svg';
import avatarImage2 from '../../assets/images/avatars/avatar-2.svg';
import avatarImage3 from '../../assets/images/avatars/avatar-3.svg';
import avatarImage4 from '../../assets/images/avatars/avatar-4.svg';
import avatarImage5 from '../../assets/images/avatars/avatar-5.svg';
import avatarImage6 from '../../assets/images/avatars/avatar-6.svg';
import avatarImage7 from '../../assets/images/avatars/avatar-7.svg';
import avatarImage8 from '../../assets/images/avatars/avatar-8.svg';
import avatarImage9 from '../../assets/images/avatars/avatar-9.svg';
import avatarImage10 from '../../assets/images/avatars/avatar-10.svg';
import avatarImage11 from '../../assets/images/avatars/avatar-11.svg';
import avatarImage12 from '../../assets/images/avatars/avatar-12.svg';
import OpenOverGokkenAvatarImage1 from '../../assets/images/avatars/open-over-gokken/avatar-1.svg';
import OpenOverGokkenAvatarImage2 from '../../assets/images/avatars/open-over-gokken/avatar-2.svg';
import OpenOverGokkenAvatarImage3 from '../../assets/images/avatars/open-over-gokken/avatar-3.svg';
import OpenOverGokkenAvatarImage4 from '../../assets/images/avatars/open-over-gokken/avatar-4.svg';
import OpenOverGokkenAvatarImage5 from '../../assets/images/avatars/open-over-gokken/avatar-5.svg';
import OpenOverGokkenAvatarImage6 from '../../assets/images/avatars/open-over-gokken/avatar-6.svg';
import OpenOverGokkenAvatarImage7 from '../../assets/images/avatars/open-over-gokken/avatar-7.svg';
import OpenOverGokkenAvatarImage8 from '../../assets/images/avatars/open-over-gokken/avatar-8.svg';
import OpenOverGokkenAvatarImage9 from '../../assets/images/avatars/open-over-gokken/avatar-9.svg';
import OpenOverGokkenAvatarImage10 from '../../assets/images/avatars/open-over-gokken/avatar-10.svg';
import OpenOverGokkenAvatarImage11 from '../../assets/images/avatars/open-over-gokken/avatar-11.svg';
import OpenOverGokkenAvatarImage12 from '../../assets/images/avatars/open-over-gokken/avatar-12.svg';
import MentaalBalansAvatarImage1 from '../../assets/images/avatars/mentaal-balans/avatar-1.svg';
import MentaalBalansAvatarImage2 from '../../assets/images/avatars/mentaal-balans/avatar-2.svg';
import MentaalBalansAvatarImage3 from '../../assets/images/avatars/mentaal-balans/avatar-3.svg';
import MentaalBalansAvatarImage4 from '../../assets/images/avatars/mentaal-balans/avatar-4.svg';
import MentaalBalansAvatarImage5 from '../../assets/images/avatars/mentaal-balans/avatar-5.svg';
import MentaalBalansAvatarImage6 from '../../assets/images/avatars/mentaal-balans/avatar-6.svg';
import MentaalBalansAvatarImage7 from '../../assets/images/avatars/mentaal-balans/avatar-7.svg';
import MentaalBalansAvatarImage8 from '../../assets/images/avatars/mentaal-balans/avatar-8.svg';
import MentaalBalansAvatarImage9 from '../../assets/images/avatars/mentaal-balans/avatar-9.svg';
import MentaalBalansAvatarImage10 from '../../assets/images/avatars/mentaal-balans/avatar-10.svg';
import MentaalBalansAvatarImage11 from '../../assets/images/avatars/mentaal-balans/avatar-11.svg';
import MentaalBalansAvatarImage12 from '../../assets/images/avatars/mentaal-balans/avatar-12.svg';

import './style.scss';

interface Props extends HTMLProps<HTMLAttributes<HTMLDivElement>> {
  avatar: number;
}

const Avatar: React.FC<Props> = ({ avatar, className }) => {
  const { buildClass, joinClasses } = useClasses('Avatar');
  const defaultAvatars: Record<number, string> = {
    1: avatarImage1,
    2: avatarImage2,
    3: avatarImage3,
    4: avatarImage4,
    5: avatarImage5,
    6: avatarImage6,
    7: avatarImage7,
    8: avatarImage8,
    9: avatarImage9,
    10: avatarImage10,
    11: avatarImage11,
    12: avatarImage12,
  };
  const zelfhulpGokkenAvatars: Record<number, string> = {
    1: OpenOverGokkenAvatarImage1,
    2: OpenOverGokkenAvatarImage2,
    3: OpenOverGokkenAvatarImage3,
    4: OpenOverGokkenAvatarImage4,
    5: OpenOverGokkenAvatarImage5,
    6: OpenOverGokkenAvatarImage6,
    7: OpenOverGokkenAvatarImage7,
    8: OpenOverGokkenAvatarImage8,
    9: OpenOverGokkenAvatarImage9,
    10: OpenOverGokkenAvatarImage10,
    11: OpenOverGokkenAvatarImage11,
    12: OpenOverGokkenAvatarImage12,
  };
  const mentaalBalansAvatars: Record<number, string> = {
    1: MentaalBalansAvatarImage1,
    2: MentaalBalansAvatarImage2,
    3: MentaalBalansAvatarImage3,
    4: MentaalBalansAvatarImage4,
    5: MentaalBalansAvatarImage5,
    6: MentaalBalansAvatarImage6,
    7: MentaalBalansAvatarImage7,
    8: MentaalBalansAvatarImage8,
    9: MentaalBalansAvatarImage9,
    10: MentaalBalansAvatarImage10,
    11: MentaalBalansAvatarImage11,
    12: MentaalBalansAvatarImage12,
  };
  const currentDomain = useSelector<ImmutableRootState<string>, string>((state) => state.getIn(['uiInternal', 'currentDomain', 'raw'], ''));
  const username = useSelector<ImmutableRootState<string>, string>((state) => {
    const uid = state.getIn(['login', 'uid']);
    return state.getIn(['user', uid, 'field_name', 0, 'value'], '');
  });

  let avatarImages = defaultAvatars;
  if (currentDomain === DOMAIN_ZELFHULP_GOKKEN) {
    avatarImages = zelfhulpGokkenAvatars;
  } else if (currentDomain === DOMAIN_MENTAAL_BALANS) {
    avatarImages = mentaalBalansAvatars;
  }

  return (
    <div className={joinClasses(buildClass(), className)}>
      <img src={String(avatarImages[avatar || 1])} alt={username} />
    </div>
  );
};

export default Avatar;
